import { Button, EmptyState } from '@bifeai/ui';
import { RotateCcw, TriangleAlert } from 'lucide-react';
import { useEffect } from 'react';
import { isRouteErrorResponse, useRouteError } from 'react-router';
import { reportClientError } from '../lib/report';

export function RouteError() {
  const error = useRouteError();
  useEffect(() => {
    if (!isRouteErrorResponse(error)) reportClientError(error, { boundary: 'route' });
  }, [error]);
  return (
    <div className="bf-center-screen">
      <EmptyState
        icon={<TriangleAlert />}
        title="Esta pantalla tuvo un problema"
        text="Quedó registrado en Errores. Recargá la página para seguir."
        action={
          <Button variant="primary" icon={<RotateCcw />} onClick={() => window.location.reload()}>
            Recargar
          </Button>
        }
      />
    </div>
  );
}
